import React, {useEffect} from 'react';

export default function StepBodyWrapper({children}) {

    const begin = () => {

    }

    const end = () => {

    }

    begin();
    useEffect(() => {
        end();
    }, []);

    return (
        <React.Fragment>
            {children}
        </React.Fragment>
    );
};
